import React from 'react'
import EyeMedModuleSelect from './EyeMedModuleSelect'
import ExamClaimForm from './exam/ExamClaimForm'
import EyeMedFinalStep from './EyeMedFinalStep'
import ContactLensClaim from './contactLens/ContactLensClaim'
import ContactLensesClaim from './contactLenses/ContactLensesClaim'
import ContactLensesDocuments from './contactLenses/ContactLensesDocuments'
import { FormSection } from 'redux-form'
import FrameClaimForm from './frame/FrameClaimForm'
import LensesClaim from './lenses/LensesClaim'

export default function EyeMedStepForm(props) {
  const { pprops: { submitEyeMedClaimForm, visionInsuranceClaimForm, claimFormTemplate, saving, editing, editing: { activeTab, activeModule }, firstStepActionLabel } } = props

  return (
    <div className='mt-7'>
      {activeTab === 'first' && <EyeMedModuleSelect visionInsuranceClaimForm={visionInsuranceClaimForm} actionLabel={firstStepActionLabel} />}
      {activeModule === 'Contact Lens Fit and Follow-up' && <FormSection name='contact_lens_fit_and_follow_up'>
        <ContactLensClaim activeTab={activeTab} claimFormTemplate={claimFormTemplate} />
      </FormSection>}
      {activeModule === 'Exam' && <FormSection name='exams'>
        <ExamClaimForm activeTab={activeTab} claimFormTemplate={claimFormTemplate} saving={saving} editing={editing} visionInsuranceClaimForm={visionInsuranceClaimForm} />
      </FormSection>}
      {activeModule === 'Frame' && <FormSection name='frames'>
        <FrameClaimForm
          activeTab={activeTab}
          claimFormTemplate={claimFormTemplate}
          visionInsuranceClaimForm={visionInsuranceClaimForm}
          submitEyeMedClaimForm={submitEyeMedClaimForm}
        />
      </FormSection>}
      {activeModule === 'Lenses' && <FormSection name='lenses'>
        <LensesClaim />
      </FormSection>}
      {activeModule === 'Contact Lenses' && <FormSection name='contact_lenses'>
        <ContactLensesClaim
          claimFormTemplate={claimFormTemplate}
          visionInsuranceClaimForm={visionInsuranceClaimForm}
        />
      </FormSection>}
      {activeTab === 'final' && <EyeMedFinalStep saving={saving} editing={editing} visionInsuranceClaimForm={visionInsuranceClaimForm} />}
      {activeTab === 'contact_lenses_docs' && <FormSection name='contact_lenses'>
        <ContactLensesDocuments />
      </FormSection>}
    </div>
  )
}
